// extracted by mini-css-extract-plugin
module.exports = {"root":"_1f_1u","v0HeroSection":"_1Vs6v","v1HeroSection":"_1Cz6s","photoHeroSection":"_1ZcIi"};